<template>
	<div class="staff-staff">
		<spinner v-if="staff.loading"/>
		<div v-if="staff.data.length" class="idi-table staff">
			<div class="idi-header">
				<div class="idi-cell">{{ $t('labels.general.name') }}</div>
				<div class="idi-cell">{{ $t('labels.general.type') }}</div>
				<div class="idi-cell">{{ $t('labels.general.created') }}</div>
				<div class="idi-cell">{{ $t('labels.general.status') }}</div>
				<div class="idi-cell"></div>
			</div>
			<div class="idi-row" v-for="member in staff.data" :key="member.id">
				<div class="idi-cell grid-area-name">{{ member.name }}</div>
				<div class="idi-cell">{{ member.type }}</div>
				<div class="idi-cell">{{ member.create_time | timeAgo(vue) }}</div>
				<div class="idi-cell">{{ member.status }}</div>
				<div class="idi-cell">
					<button-icon :to="{ name: 'UserProfileStaffStaffForm', params: { user_uid, staff_id: member.id, data: member } }" icon="edit" title="Edit"/>
				</div>
			</div>
		</div>
		<p v-if="!staff.loading && !staff.data.length" class="no-results">{{ $t('labels.general.no_results') }}</p>
		<router-view/>
	</div>
</template>

<script>
import ApiCollection from '@/classes/api/ApiCollection'
export default {
	props: [
		'user_uid'
	],
	data () {
		return {
			vue: this,
			staff: new ApiCollection
		}
	},
	methods: {
		getStaff () {
			this.staff.loading = true
			this.staff.data = []
			this.$api.staff.getAll(this, this.user_uid).then(response => {
				this.$log.info('staff staff', 'staff.getAll OK', response)()
				this.staff.data = response.body.map(ele => {
					ele.status = ele.active ? 'Enabled' : 'Disabled'
					return ele
				})
			}).catch(error => {
				this.$log.error('staff staff', 'staff.getAll ERROR', error)()
				this.staff.error = error
			}).finally(() => {
				this.staff.loading = false
			})
		},
	},
	mounted () {
		this.getStaff()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/staff/StaffStaff.vue